export class ThemeEvents {
  static discountUpdate = "discount:update";
}

export class DiscountUpdateEvent extends Event {
  constructor(resource, sourceId) {
    super(ThemeEvents.discountUpdate, { bubbles: true });
    this.detail = { resource, sourceId };
  }
}

document.addEventListener("cart-update", () => {
  localStorage.removeItem("shippingRates");
  localStorage.removeItem("selectedShippingRate");

  // Auto-recalcular frete se há CEP salvo
  const cartShippingComponent = document.querySelector(
    "cart-shipping-component"
  );

  if (cartShippingComponent) {
    cartShippingComponent.autoRecalculateShipping();
  }
});

// Listener para eventos de desconto (cupons aplicados/removidos)
document.addEventListener("discount:update", () => {
  localStorage.removeItem("shippingRates");
  localStorage.removeItem("selectedShippingRate");

  // Auto-recalcular frete se há CEP salvo
  const cartShippingComponent = document.querySelector(
    "cart-shipping-component"
  );
  if (cartShippingComponent) {
    cartShippingComponent.autoRecalculateShipping();
  }
});
